import React from 'react';
import Modal from '../../../../component/modal/Modal';
import InputField from '../../../../component/form/FormInput';
import InputSelect from '../../../../component/inputSelect/InputSelect';
import Button from '../../../../component/ui/Button';
import useTransport from '../../hooks/useTransport';
import { getCurrentDate } from '../../../../utils/dateUtils';

function AddEWayBillFormModal({
	isBillModalOpen,
	setIsBillModalOpen,
	setPurchaseBillFormData,
	purchaseBillFormData,
	isEWayBillStatus,
	setIsEWayBillStatus,
	errorEwayBill,
	setErrorEwayBill,
	isTransportFocus,
	setIsTransportType,
	setIsTransportFocus,
}) {
	const { transportList, setSearchTransport } = useTransport();

	function handleEwayBill() {
		let newError = { ...errorEwayBill };
		if (
			!purchaseBillFormData?.e_way_bill?.e_way_bill_no ||
			purchaseBillFormData?.e_way_bill?.e_way_bill_no === '' ||
			purchaseBillFormData?.e_way_bill?.e_way_bill_no === undefined
		) {
			newError.e_way_bill_no = 'Please enter bill number in the field';
		} else {
			delete newError.e_way_bill_no;
		}
		if (
			!purchaseBillFormData?.e_way_bill?.challan_no ||
			purchaseBillFormData?.e_way_bill?.challan_no === '' ||
			purchaseBillFormData?.e_way_bill?.challan_no === undefined
		) {
			newError.challan_no = 'Please enter challan number in the field';
		} else {
			delete newError.challan_no;
		}
		if (
			!purchaseBillFormData?.e_way_bill?.transport ||
			purchaseBillFormData?.e_way_bill?.transport === '' ||
			purchaseBillFormData?.e_way_bill?.transport === undefined
		) {
			newError.transport = 'Please enter transport in the field';
		} else {
			delete newError.transport;
		}
		if (
			!purchaseBillFormData?.e_way_bill?.cases ||
			purchaseBillFormData?.e_way_bill?.cases === '' ||
			purchaseBillFormData?.e_way_bill?.cases === undefined
		) {
			newError.cases = 'Please enter cases in the field';
		} else {
			delete newError.cases;
		}
		if (
			!purchaseBillFormData?.e_way_bill?.purchase_tax ||
			purchaseBillFormData?.e_way_bill?.purchase_tax === '' ||
			purchaseBillFormData?.e_way_bill?.purchase_tax === undefined
		) {
			newError.purchase_tax = 'Please enter purchase tax in the field';
		} else {
			delete newError.purchase_tax;
		}

		if (Object.keys(newError).length > 0) {
			setErrorEwayBill(newError);
			setPurchaseBillFormData((prev) => ({
				...prev,
				e_way_bill: {
					...prev.e_way_bill,
					e_way_bill_status: false,
				},
			}));
		} else {
			setIsBillModalOpen(false);
			setErrorEwayBill(newError);
			setPurchaseBillFormData((prev) => ({
				...prev,
				e_way_bill: {
					...prev.e_way_bill,
					e_way_bill_status: true,
				},
			}));
		}
	}

	return (
		<Modal
			className=" billModal"
			isOpen={isBillModalOpen}
			onClose={() => {
				setIsBillModalOpen(false);
				if (!isEWayBillStatus) {
					setPurchaseBillFormData((prev) => ({
						...prev,
						e_way_bill: {
							e_way_bill_no: '',
							challan_no: '',
							date: '',
							transport: '',
							cases: '',
							purchase_tax: '',
							remarks: '',
						},
					}));
					setIsEWayBillStatus(false);
				}
			}}
			cancelButton={() => {
				setIsBillModalOpen(false);
				if (!isEWayBillStatus) {
					setPurchaseBillFormData((prev) => ({
						...prev,
						e_way_bill: {
							e_way_bill_no: '',
							challan_no: '',
							date: '',
							transport: '',
							cases: '',
							purchase_tax: '',
							remarks: '',
						},
					}));
					setIsEWayBillStatus(false);
				}
			}}
			title={
				<div
					style={{
						fontWeight: '600',
						color: '#000000',
						fontSize: '15px',
					}}
				>
					Add E-Way Bill Details
				</div>
			}
			// headerClassName="discard-header"
			// bodyClassName="discard-Body"
		>
			<div>
				<div className="row">
					<div className="col">
						<InputField
							label="E-Way Bill No."
							placeholder="Enter E-Way Bill No"
							required={true}
							value={purchaseBillFormData.e_way_bill.e_way_bill_no}
							onChange={(value) =>
								setPurchaseBillFormData((prev) => ({
									...prev,
									e_way_bill: {
										...prev.e_way_bill,
										e_way_bill_no: value,
									},
								}))
							}
							autoComplete={'E-way Bill No'}
							name="E-way Bill No"
							error={errorEwayBill?.e_way_bill_no}
							autoFocus={true}
						/>
					</div>
					<div className="col">
						<InputField
							label="Challan No."
							placeholder="Enter Challan No"
							autoComplete={'Challan No'}
							name="Challan No"
							type="text"
							value={purchaseBillFormData.e_way_bill.challan_no}
							onChange={(value) =>
								setPurchaseBillFormData((prev) => ({
									...prev,
									e_way_bill: {
										...prev.e_way_bill,
										challan_no: value,
									},
								}))
							}
							required={true}
							error={errorEwayBill?.challan_no}
						/>
					</div>
					<div className="col">
						<InputField
							label="E-Way Bill Date"
							placeholder="Enter E-Way Bill Date"
							autoComplete={'E-Way Bill Date'}
							name="E-Way Bill Date"
							type="date"
							value={purchaseBillFormData.e_way_bill.date}
							onBlur={(e) => {
								let value = e.target.value;
								const newError = { ...errorEwayBill };
								var date = new Date(value);
								var currentDate = new Date();
								currentDate.setDate(currentDate.getDate() + 1);
								let year = date.getFullYear().toString();
								if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
									delete newError.date;
									setErrorEwayBill(newError);
									setPurchaseBillFormData((prev) => ({
										...prev,
										e_way_bill: {
											...prev.e_way_bill,
											date: value,
										},
									}));
								} else if (
									year.length === 4 &&
									new Date(value) > currentDate.setHours(0, 0, 0, 0)
								) {
									newError.date = 'Date cannot be in the future';
									setErrorEwayBill(newError);
									setPurchaseBillFormData((prev) => ({
										...prev,
										e_way_bill: {
											...prev.e_way_bill,
											date: value,
										},
									}));
								} else {
									delete newError.date;
									setErrorEwayBill(newError);
									setPurchaseBillFormData((prev) => ({
										...prev,
										e_way_bill: {
											...prev.e_way_bill,
											date: value,
										},
									}));
								}
							}}
							onChange={(value) => {
								setPurchaseBillFormData((prev) => ({
									...prev,
									e_way_bill: {
										...prev.e_way_bill,
										date: value,
									},
								}));
							}}
							required={true}
							error={errorEwayBill?.date}
							max={getCurrentDate()}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col">
						<InputSelect
							options={transportList}
							label="Transport"
							placeholder="Enter Transport Agency Name"
							required={true}
							returnInputValue={false}
							value={purchaseBillFormData.e_way_bill.transport}
							onSelect={(option) => {
								setPurchaseBillFormData((prev) => ({
									...prev,
									e_way_bill: {
										...prev.e_way_bill,
										transport: option.value,
									},
								}));
							}}
							onChange={(value) => {
								setSearchTransport(value);
							}}
							error={errorEwayBill?.transport}
							autoFocus={isTransportFocus}
							onAddNew={() => {
								setIsTransportType(true);
								setIsTransportFocus(false);
							}}
						/>
					</div>
					<div className="col">
						<InputField
							label="Cases"
							placeholder="Enter Number of Cases"
							autoComplete={'Cases'}
							type="text"
							name="Cases"
							required={true}
							value={purchaseBillFormData.e_way_bill.cases}
							onChange={(value) => {
								setPurchaseBillFormData((prev) => ({
									...prev,
									e_way_bill: {
										...prev.e_way_bill,
										cases: value?.replace(/[^0-9]/g, ''),
									},
								}));
							}}
							error={errorEwayBill?.cases}
						/>
					</div>
					<div className="col">
						<InputField
							label="Purchase Tax"
							placeholder="Enter Purchase Tax"
							autoComplete={'Purchase Tax'}
							name="Purchase Tax"
							type="text"
							value={purchaseBillFormData.e_way_bill.purchase_tax}
							onChange={(value) => {
								let valueData = value?.replace(/[^0-9.]/g, '');
								const decimalCount = (valueData.match(/\./g) || []).length;
								if (decimalCount > 1) {
									valueData = +valueData?.slice(0, valueData.lastIndexOf('.'));
								}
								setPurchaseBillFormData((prev) => ({
									...prev,
									e_way_bill: {
										...prev.e_way_bill,
										purchase_tax: valueData,
									},
								}));
							}}
							required={true}
							error={errorEwayBill?.purchase_tax}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col">
						<InputField
							label="Remarks"
							autoComplete={'Remarks'}
							name="Remarks"
							placeholder="Enter Remarks"
							value={purchaseBillFormData.e_way_bill.remarks}
							onChange={(value) =>
								setPurchaseBillFormData((prev) => ({
									...prev,
									e_way_bill: {
										...prev.e_way_bill,
										remarks: value,
									},
								}))
							}
							required={false}
						/>
					</div>
				</div>

				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'start',
						gap: 12,
						marginTop: '10px',
					}}
				>
					<Button
						type="button"
						className="mt-0 add-pro bill"
						button="Save E-Way Bill"
						onClick={() => handleEwayBill()}
					/>
					<Button
						type="button"
						className="mt-0 add-pro bill2"
						button="Cancel"
						onClick={() => {
							setIsBillModalOpen(false);
							if (!isEWayBillStatus) {
								setPurchaseBillFormData((prev) => ({
									...prev,
									e_way_bill: {
										e_way_bill_no: '',
										challan_no: '',
										due_date: '',
										transport: '',
										cases: '',
										purchase_tax: '',
										remarks: '',
									},
								}));
								setIsEWayBillStatus(false);
							}
						}}
					/>
				</div>
			</div>
		</Modal>
	);
}

export default AddEWayBillFormModal;
